import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";
import { brand, nav } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#0a0b0d] border-t border-[#1c1e23] pt-20 pb-10">
      <div className="af-container">
        <div className="grid md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src={brand.logo}
                alt="August Doors & Windows"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-[var(--af-muted)] max-w-sm leading-relaxed">
              {brand.tagline}
            </p>
            <div className="flex gap-3 mt-6 text-xs tracking-[0.28em] uppercase text-[var(--af-muted)]">
              <span>Manufacture</span>
              <span className="text-[var(--af-blue)]">·</span>
              <span>Supply</span>
              <span className="text-[var(--af-blue)]">·</span>
              <span>Install</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow mb-6">Explore</h4>
            <ul className="space-y-3">
              {nav.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-white/75 hover:text-white transition-colors hover-underline"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow mb-6">Get in touch</h4>
            <a
              href={brand.mapUrl}
              target="_blank"
              rel="noreferrer"
              className="flex items-start gap-3 text-white/75 hover:text-white transition-colors mb-5"
            >
              <MapPin size={18} className="mt-1 text-[var(--af-blue)] shrink-0" />
              <span>{brand.address}</span>
            </a>
            <a
              href={brand.phoneHref}
              className="flex items-center gap-3 text-white/75 hover:text-white transition-colors mb-5"
            >
              <Phone size={18} className="text-[var(--af-blue)]" />
              {brand.phone}
            </a>
            <a
              href={brand.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-[#2c2f37] text-white hover:border-[var(--af-green)] hover:text-[var(--af-green)] transition-all"
            >
              <MessageCircle size={16} /> Chat on WhatsApp
              <ArrowUpRight size={15} />
            </a>
          </div>
        </div>

        <div className="border-t border-[#1c1e23] pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[var(--af-muted)]">
          <p>© {new Date().getFullYear()} August Doors & Windows. All rights reserved.</p>
          <p>Darbhanga, Bihar · India</p>
        </div>
      </div>
    </footer>
  );
}
